/* eslint-disable @typescript-eslint/no-unused-vars */

import { InputWithLabel } from '@adotel/components'
import SearchIcon from '@material-ui/icons/Search'
import { useEffect, useState } from 'react'

import ActiveTabs from '../../components/ActiveTabs'
import { convertPersianNumbersToEnglishNumbers } from '../../helpers/numbers'
import { getTranslate } from '../../localization'
import { RolesFilters } from '../../types/role'
import useStyles from './styles/TemplatesFilters.styles'

interface RoleFiltersProps {
  getRolesFilters: RolesFilters
  setGetRolesFilters: React.Dispatch<React.SetStateAction<RolesFilters>>
}

const RoleFilters: React.FC<RoleFiltersProps> = ({
  getRolesFilters,
  setGetRolesFilters
}) => {
  const classes = useStyles()
  const [activeStatus, setaAtiveStatus] = useState('All')
  useEffect(() => {
    setGetRolesFilters({
      ...getRolesFilters,
      isActive:
        activeStatus === 'Active'
          ? true
          : activeStatus === 'Deactive'
          ? false
          : undefined
    })
  }, [activeStatus])

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <ActiveTabs
          title={'Status'}
          value={activeStatus}
          setValue={setaAtiveStatus}
        />
        <InputWithLabel
          label={getTranslate('Role Name')}
          placeholder={getTranslate('Search in role names')}
          autoComplete="off"
          noHelperText
          fullWidth
          startIcon={<SearchIcon />}
          inputSize="small"
          value={getRolesFilters.roleName}
          onChange={(event) =>
            setGetRolesFilters({
              ...getRolesFilters,
              roleName: convertPersianNumbersToEnglishNumbers(
                event.currentTarget.value
              )
            })
          }
        />
      </div>
    </div>
  )
}

export default RoleFilters
